<template>
  <div class="about-us">
    <img class="about-us-img" :src="appData.merRegardUrl" />
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
    //   urlPath: this.appData.merRegardUrl,
    };
  },
  methods: {},
  mounted() {
    // Add your mounted logic here
  },
};
</script>

<style lang="less" scoped>
.about-us {
  /* Add your component styles here */
  background: white;
  .about-us-img {
    width: 100%;
  }
}
</style>
